module.exports = __webpack_public_path__ + "img/ipad.8cd5778c.png";